var React = require('react');

function TickGreen (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("circle",{"cx":"12","cy":"12","r":"9","fill":"#5FBE85","stroke":"#5FBE85","key":0}),React.createElement("path",{"stroke":"#FFF","d":"M16.287 8.942l-6.095 6.367L7.56 12.81","key":1})]));
}

TickGreen.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = TickGreen;

TickGreen.default = TickGreen;
